import React, { useState } from 'react';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';
import { Toaster } from './ui/toaster';

const AdminApp = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (authenticated) => {
    setIsAuthenticated(authenticated);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  return (
    <div>
      {isAuthenticated ? (
        <div>
          {/* Bouton de déconnexion */}
          <div className="fixed top-4 right-4 z-50">
            <button
              onClick={handleLogout}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg transition-colors"
            >
              Déconnexion
            </button>
          </div>
          <AdminPanel />
        </div>
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
      <Toaster />
    </div>
  );
};

export default AdminApp;